import { Divider, TextField, MenuItem, Chip } from "@mui/material";
import * as React from "react";
import styled from "styled-components";
import BasicButtons from "../../UI/BasicButtons";
import { PDFDownloadLink } from "@react-pdf/renderer";
import RaschetPDFFile from "./PDFraschet";
import InputAdornment from "@mui/material/InputAdornment";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import Modal from "../../UI/Modal";
import Nomenklatury from "../../spravochniki/nomenklatura/Nomenklatury";
import { useGetKiQuery } from "../../../store/coefficientsApi/kiApi";
import { useGetKzQuery } from "../../../store/coefficientsApi/kzApi";
import { useGetK3Query } from "../../../store/coefficientsApi/k3Api";
import { useGetOrganizationQuery } from "../../../store/organizationApi";
import { useUpdateRaschetMutation } from "../../../store/coefficientsApi/raschetApi";

export default function Raschet({ item, onClose, id }) {
  const { data: kiFB } = useGetKiQuery();
  const { data: kzFB } = useGetKzQuery();
  const { data: k3FB } = useGetK3Query();
  const { data: organizationFB } = useGetOrganizationQuery();
  const [updateData] = useUpdateRaschetMutation();
  const [docDate, setDocDate] = React.useState(item.attributes.docDate);
  const [docNumber, setDocNumber] = React.useState(item.attributes.docNumber);
  const [address, setAddress] = React.useState(
    item.attributes.nomenklatura.data[0].attributes.address +
      " " +
      item.attributes.nomenklatura.data[0].attributes.addressNumber
  );
  const [nomenklatura, setNomenklatura] = React.useState(
    item.attributes.nomenklatura.data[0].attributes.name
  );
  const [nomenklaturaID, setNomenklaturaID] = React.useState(
    item.attributes.nomenklatura.data[0].id
  );
  const [identCode, setIdentCode] = React.useState(
    item.attributes.nomenklatura.data[0].attributes.inventNumber
  );
  const [square, setSquare] = React.useState(
    item.attributes.nomenklatura.data[0].attributes.square
  );
  const [coordinates, setCoordinates] = React.useState(
    item.attributes.nomenklatura.data[0].attributes.coordinates
  );
  const [category, setCategory] = React.useState(
    item.attributes.nomenklatura.data[0].attributes.category.data[0].attributes
  );
  const [k2, setK2] = React.useState(
    item.attributes.nomenklatura.data[0].attributes.k2.data[0].attributes
  );
  const [k1, setK1] = React.useState(
    item.attributes.nomenklatura.data[0].attributes.k1.data[0].attributes
  );
  const [k4, setK4] = React.useState(
    item.attributes.nomenklatura.data[0].attributes.k4.data[0].attributes
  );
  const [k3, setK3] = React.useState([]);
  const [k3ID, setK3ID] = React.useState(item.attributes.k3.data[0].id);
  const [k3value, setK3value] = React.useState(
    item.attributes.k3.data[0].attributes.value
  );
  const [ki, setKi] = React.useState({ attributes: { value: " " } });
  const [kz, setKz] = React.useState({ attributes: { value: " " } });
  const [sum, setSum] = React.useState(item.attributes.sum);
  const [nalog, setNalog] = React.useState(item.attributes.nalog);
  const [autor, setAutor] = React.useState(
    item.attributes.user.data[0].attributes.username
  );
  const [organization, setOrganization] = React.useState({
    attributes: { shortTitle: " " },
  });
  const [modalForNomenklatury, setModalForNomenklatury] = React.useState(false);

  React.useEffect(() => {
    const setDataToStates = async () => {
      try {
        const k3s = await k3FB.data;
        const kis = await kiFB.data;
        const kzs = await kzFB.data;
        const organizationData = await organizationFB.data;
        setK3(k3s);
        setKi(kis);
        setKz(kzs);
        setOrganization(organizationData);
      } catch (error) {}
    };
    setDataToStates();
  }, [kiFB, kzFB, k3FB, organizationFB]);

  const inputChangeHandler = (event, setValue) => {
    setValue(event.target.value);
  };

  const nomenklaturaChangeHandler = () => {
    window.alert("Нажмите на троеточие и выберите элемент из списка");
  };

  const getNomenklaturaItem = (item) => {
    setNomenklatura(item.attributes.name);
    setIdentCode(item.attributes.inventNumber);
    setSquare(item.attributes.square);
    setAddress(item.attributes.address + " " + item.attributes.addressNumber);
    setCoordinates(item.attributes.coordinates);
    setCategory(item.attributes.category.data[0].attributes);
    setK2(item.attributes.k2.data[0].attributes);
    setK1(item.attributes.k1.data[0].attributes);
    setK4(item.attributes.k4.data[0].attributes);
    setNomenklaturaID(item.id);
  };

  const getK3values = (id, value) => {
    setK3ID(id);
    setK3value(value);
  };

  const onClickCalculate = () => {
    const resultSum =
      Number(category.value) *
      Number(square) *
      Number(k1.value) *
      Number(k2.value) *
      Number(k3value) *
      Number(k4.value);
    const resultNalog =
      Number(category.value) *
      Number(square) *
      Number(ki.attributes.value) *
      Number(kz.attributes.value) *
      Number(k2.value);
    setSum(resultSum.toFixed(3));
    setNalog(resultNalog.toFixed(3));
  };

  const formSubmitHandler = (event) => {
    event.preventDefault();
    window.confirm("Вы уверены?");
    const updated = {
      docDate,
      docNumber,
      sum,
      nalog,
      k3: k3ID,
      nomenklatura: nomenklaturaID,
      user: 1,
    };
    updateData({ updated, id });
    onClose();
  };

  return (
    <StyledForm onSubmit={formSubmitHandler}>
      <BlockStyled display="flex" justifyContent="space-between">
        <TitleOfCreation>Добавить расчет</TitleOfCreation>
        <TitleOfCreation>Формула расчета: A=C*S*K1*K2*K3*K4</TitleOfCreation>
      </BlockStyled>
      <BlockStyled margin="0 0 20px 0" width="100%">
        <BlockStyled width="100%" display="flex" justifyContent="flex-start">
          <TextFieldStylded
            id="date"
            type="date"
            InputLabelProps={{ shrink: true }}
            label="Дата документа"
            variant="outlined"
            value={docDate}
            onChange={(event) => inputChangeHandler(event, setDocDate)}
            size="small"
            width="150px"
            mrg="0 10px 0 0"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="№ документа"
            variant="outlined"
            value={docNumber}
            onChange={(event) => inputChangeHandler(event, setDocNumber)}
            size="small"
            width="15%"
            mrg="0 15px 0 0"
          />
          <TextFieldStylded
            id="select"
            select
            label="(К3)Коэффициент определямый от сроков предоставления земельного участка"
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            variant="outlined"
            size="small"
            value={k3.length ? k3ID : ""}
            width="50%"
          >
            {k3.map((item) => {
              return (
                <MenuItem
                  key={item.id}
                  value={item.id}
                  onClick={() => getK3values(item.id, item.attributes.value)}
                >
                  {item.attributes.title}
                </MenuItem>
              );
            })}
          </TextFieldStylded>
        </BlockStyled>
        <BlockStyled
          width="100%"
          margin="20px 0 0 0"
          display="flex"
          justifyContent="flex-start"
        >
          <TextFieldStylded
            id="outlined-basic"
            label="(Ки)Коэффициент инфляции"
            variant="outlined"
            size="small"
            value={ki.attributes.value}
            width="20%"
            mrg="0 15px 0 0"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="(Ки)Коэффициент зональности"
            variant="outlined"
            size="small"
            value={kz.attributes.value}
            width="20%"
            mrg="0 15px 0 0"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="Сумма расчета"
            variant="outlined"
            value={sum}
            size="small"
            width="15%"
            mrg="0 15px 0 0"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="Налог"
            variant="outlined"
            value={nalog}
            size="small"
            width="15%"
            mrg="0 15px 0 0"
          />
          <BasicButtons margin={"0 0 0 0"} onClick={onClickCalculate}>
            Пересчитать
          </BasicButtons>
        </BlockStyled>
      </BlockStyled>
      <DividerStyled sx={{ margin: "20px 0" }} width="60%">
        <Chip label="Номенклатура" />
      </DividerStyled>
      <BlockStyled
        margin="20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          InputLabelProps={{ shrink: true }}
          label="Номеклатура"
          id="outlined-end-adornment"
          mrg="0 20px 0 0"
          width="45%"
          value={nomenklatura}
          onChange={nomenklaturaChangeHandler}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconStyled
                  onClick={() => setModalForNomenklatury(true)}
                  color="primary"
                />
              </InputAdornment>
            ),
          }}
        />
        <Modal
          fullwidth={"60%"}
          isOpen={modalForNomenklatury}
          onClose={() => setModalForNomenklatury(false)}
        >
          <Nomenklatury
            onCloseNomenklatury={() => setModalForNomenklatury(false)}
            getNomenklaturaItem={getNomenklaturaItem}
            checkBusy={false}
          />
        </Modal>

        <TextFieldStylded
          id="outlined-basic"
          label="Идентификационный код"
          value={identCode}
          onChange={(event) => inputChangeHandler(event, setIdentCode)}
          width="40%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="(S)Площадь"
          // inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          variant="outlined"
          value={square}
          onChange={(event) => inputChangeHandler(event, setSquare)}
          width="10%"
        />
      </BlockStyled>
      <BlockStyled
        margin="0 0 20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          id="outlined-basic"
          label="Адрес"
          variant="outlined"
          value={address}
          onChange={(event) => inputChangeHandler(event, setAddress)}
          width="48%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Координаты"
          variant="outlined"
          value={coordinates}
          width="48%"
        />
      </BlockStyled>
      <BlockStyled margin="0 0 20px 0">
        <TextFieldStylded
          InputLabelProps={{ shrink: true }}
          id="outlined-basic"
          label="(C)Категория"
          variant="outlined"
          value={category.name}
          width="100%"
        />
      </BlockStyled>
      <BlockStyled margin="0 0 20px 0">
        <TextFieldStylded
          InputLabelProps={{ shrink: true }}
          id="outlined-basic"
          label="(K2)Коэффициент коммерческого использования"
          variant="outlined"
          value={k2.title}
          width="100%"
        />
      </BlockStyled>
      <BlockStyled margin="0 0 20px 0">
        <TextFieldStylded
          InputLabelProps={{ shrink: true }}
          id="outlined-basic"
          label="(K1)Коэффициент определяемый от месторасположения участка"
          variant="outlined"
          value={k1.title}
          width="100%"
        />
      </BlockStyled>
      <BlockStyled margin="0 0 20px 0">
        <TextFieldStylded
          InputLabelProps={{ shrink: true }}
          id="outlined-basic"
          label="(K4)Коффициент определяемый от общей площади предоставляемого земельного участка"
          variant="outlined"
          value={k4.title}
          width="100%"
        />
      </BlockStyled>
      <StyledButtonsdBlock>
        <BlockStyled
          display="flex"
          flexDirection="flex-start"
          alignItems="center"
        >
          <TextFieldStylded
            id="outlined-basic"
            label="Автор"
            variant="outlined"
            value={autor}
            onChange={(event) => inputChangeHandler(event, setAutor)}
            width="180px"
            size="small"
          />
        </BlockStyled>

        <BlockStyled display="flex" flexDirection="flex-end">
          <PDFDownloadLink
            document={
              <RaschetPDFFile
                docDate={docDate}
                docNumber={docNumber}
                address={address}
                k1={k1}
                k2={k2}
                k3={k3value}
                k4={k4}
                ki={ki.attributes}
                kz={kz.attributes}
                square={square}
                category={category.value}
                sum={sum}
                nalog={nalog}
                shortOrg={organization.attributes.shortTitle}
                autor={autor}
              />
            }
            fileName={`Raschet_№${docNumber}_${new Date(
              docDate
            ).toLocaleDateString()}.pdf`}
          >
            {({ loading }) =>
              loading ? (
                <BasicButtons>pdf...</BasicButtons>
              ) : (
                <BasicButtons>pdf</BasicButtons>
              )
            }
          </PDFDownloadLink>
          <BasicButtons onClick={onClose}>Отменить</BasicButtons>
          <BasicButtons type="submit">Сохранить</BasicButtons>
        </BlockStyled>
      </StyledButtonsdBlock>
    </StyledForm>
  );
}

const BlockStyled = styled.div`
  width: ${(props) => props.width};
  display: ${(props) => props.display};
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.flexDirection};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  align-items: ${(props) => props.alignItems};
`;

const TextFieldStylded = styled(TextField)`
  width: ${(props) => props.width};
  margin: ${(props) => props.mrg};
`;

const DividerStyled = styled(Divider)`
  margin: ${(props) => props.margin};
`;
const IconStyled = styled(MoreHorizTwoToneIcon)`
  cursor: pointer;
`;
const StyledButtonsdBlock = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
`;
const TitleOfCreation = styled.h3`
  text-align: center;
`;

const StyledForm = styled.form``;
